/* ARBACH — Header-Logo-Shrink beim Scrollen (Agent A3, Paket 10).
   Eigene Datei. arbach.js wird NICHT angefasst — die gehoert A6.

   Vertrag mit A2 (identischer Wortlaut in Paket 5, bindend):
   - Diese Datei setzt/entfernt ausschliesslich die Klasse 'is-shrunk' auf
     '.arbach-header__mobile' (dem ELTERNKNOTEN, nicht auf .arbach-header__bar).
     Das Styling macht A2 vollstaendig in CSS.
   - Bar normal 64px (4rem), geschrumpft 48px (3rem) — Kalibrierungsgrundlage.

   Umsetzung laut Auftrag:
   - Scroll-Listener mit { passive: true } + requestAnimationFrame-Throttle
     (ticking-Flag). KEIN IntersectionObserver, KEIN Sentinel — .arbach-header__mobile
     hat ein padding-top in Bar-Hoehe, ein Sentinel laege schon bei scrollY === 0
     jenseits der Schwelle und der Header wuerde geschrumpft laden.
   - Hysterese: setzen ab scrollY > 60, entfernen erst bei scrollY < 20.
   - Nur unter 1024px: matchMedia('(max-width: 1023.98px)') plus change-Listener;
     beim Verlassen des Mobil-Breakpoints die Klasse entfernen.
   - shopify:section:load behandeln, auf event.target gescopt, mit
     Idempotenz-Guard (Datenattribut) gegen doppelte Listener.
   - Initialzustand beim Laden einmal setzen (Rueckwaertsnavigation kann mit
     scrollY > 0 laden).

   Stil (Regel 6, nicht verhandelbar): reines ES5 wie arbach.js — var, function,
   Array.prototype.slice.call. Keine Arrow-Functions, kein let/const, kein
   Optional Chaining, keine Template-Strings. Eigene IIFE mit eigenem
   'use strict' und eigenem readyState-Guard. Kein Build-Step vorhanden. */
(function () {
  'use strict';

  var MOBILE_CLASS = 'arbach-header__mobile';
  var SELECTOR = '.' + MOBILE_CLASS;
  var SHRUNK_CLASS = 'is-shrunk';
  /* Idempotenz-Guard: markiert bereits erfasste Knoten, damit ein Re-Init nach
     shopify:section:load denselben Knoten nicht ein zweites Mal registriert. */
  var GUARD_ATTR = 'data-arbach-shrink';
  var MOBILE_QUERY = '(max-width: 1023.98px)';

  /* Hysterese statt einer einzigen Schwelle. Der Shrink nimmt der fixen Bar
     16px (64px -> 48px); die statische Reserve in Z. 16 schrumpft laut Vertrag
     NICHT mit, der Inhalt springt also nicht. Der Sicherheitsabstand von 40px
     zwischen den beiden Schwellen liegt trotzdem deutlich ueber dieser
     Differenz — damit kann aus dem Zustandswechsel keine Schleife entstehen.
     ON_AT liegt bei 80 (Runde 2, vorher 60): der Kontaktstreifen unter der Bar
     (Dokument-y 64-120) muss vollstaendig weggescrollt sein, BEVOR die Bar
     schrumpft — sonst lugt beim Uebergang ein ~11px-Streifenrest unter der
     geschrumpften 48px-Bar hervor. Minimum waere 72 (=120-48); 80 gibt Reserve. */
  var ON_AT = 80;
  var OFF_AT = 40;

  /* Ohne matchMedia bleibt die Funktion inaktiv (Desktop-Verhalten), statt zu
     raten — dieselbe defensive Abfrage wie in arbach.js. */
  var mql = window.matchMedia ? window.matchMedia(MOBILE_QUERY) : null;

  var headers = [];
  var isShrunk = false;
  var ticking = false;
  var bound = false;

  function schedule(fn) {
    if (window.requestAnimationFrame) { return window.requestAnimationFrame(fn); }
    return window.setTimeout(fn, 16);
  }

  function isMobile() {
    return mql ? mql.matches : false;
  }

  function scrollOffset() {
    if (typeof window.pageYOffset === 'number') { return window.pageYOffset; }
    var root = document.documentElement || document.body;
    return root ? root.scrollTop || 0 : 0;
  }

  /* Schreibt den aktuellen Zustand auf alle erfassten Elternknoten. */
  function write() {
    for (var i = 0; i < headers.length; i++) {
      if (isShrunk) { headers[i].classList.add(SHRUNK_CLASS); }
      else { headers[i].classList.remove(SHRUNK_CLASS); }
    }
  }

  /* force === true schreibt auch dann, wenn sich der Zustand nicht geaendert
     hat — noetig fuer Erstlauf, Breakpoint-Wechsel und frisch gerenderte
     Section-Knoten. */
  function evaluate(force) {
    var next;
    var y;
    if (!isMobile()) {
      next = false;
    } else {
      y = scrollOffset();
      if (y > ON_AT) { next = true; }
      else if (y < OFF_AT) { next = false; }
      else { next = isShrunk; }
    }
    if (next === isShrunk && force !== true) { return; }
    isShrunk = next;
    write();
  }

  function onScroll() {
    if (ticking) { return; }
    ticking = true;
    schedule(function () {
      /* Erst freigeben, dann messen: ein Scroll waehrend der Auswertung plant
         so sauber den naechsten Frame. */
      ticking = false;
      evaluate(false);
    });
  }

  function refresh() {
    evaluate(true);
  }

  /* Entfernt Knoten, die ein Section-Reload aus dem Dokument genommen hat. */
  function prune() {
    var live = [];
    var root = document.documentElement;
    for (var i = 0; i < headers.length; i++) {
      if (root && root.contains(headers[i])) { live.push(headers[i]); }
    }
    headers = live;
  }

  /* Erfasst neue Elternknoten innerhalb von scope. Rueckgabe: Anzahl der
     wirklich neu registrierten Knoten. */
  function collect(scope) {
    var root = (scope && scope.querySelectorAll) ? scope : document;
    var found = Array.prototype.slice.call(root.querySelectorAll(SELECTOR));
    var added = 0;
    var el;
    if (root !== document && root.classList && root.classList.contains(MOBILE_CLASS)) {
      found.push(root);
    }
    for (var i = 0; i < found.length; i++) {
      el = found[i];
      if (el.getAttribute(GUARD_ATTR) === 'on') { continue; }
      el.setAttribute(GUARD_ATTR, 'on');
      headers.push(el);
      added++;
    }
    return added;
  }

  /* Theme-Editor: eine geaenderte Header-Einstellung rendert
     .arbach-header__mobile neu, der alte Knoten ist verwaist. Auf event.target
     gescopt, damit Section-Loads anderer Sections nichts anfassen. Die
     globalen Listener haengen an window/document und werden hier bewusst NICHT
     erneut gebunden — bound sorgt dafuer, dass es sie genau einmal gibt. */
  function onSectionLoad(event) {
    var target = (event && event.target) ? event.target : document;
    prune();
    if (collect(target) > 0) { refresh(); }
  }

  function bind() {
    if (bound) { return; }
    bound = true;
    window.addEventListener('scroll', onScroll, { passive: true });
    /* pageshow deckt Rueckwaertsnavigation ab: sowohl bfcache-Restore als auch
       eine nachtraegliche Scroll-Wiederherstellung landen hier. */
    window.addEventListener('pageshow', refresh);
    if (mql) {
      if (mql.addEventListener) { mql.addEventListener('change', refresh); }
      else if (mql.addListener) { mql.addListener(refresh); }
    }
    document.addEventListener('shopify:section:load', onSectionLoad);
  }

  function init() {
    bind();
    collect(document);
    /* Initialzustand einmal setzen — die Seite kann mit scrollY > 0 laden. */
    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
